import React, { useState } from "react"
import Leaflet from "leaflet"
import { Map, TileLayer, Marker } from "react-leaflet"
import "./map.css"
import "../../../../../node_modules/leaflet/dist/leaflet.css"
import { useTranslation } from "react-i18next"

// Set default icon URLs for Leaflet markers
Leaflet.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
})

// Customer data with coordinates and active user count
const customerLocations = [
  {
    id: 1,
    lat: 25.2048,
    lng: 55.2708,
    activeCount: 25,
  },
  {
    id: 2,
    lat: 25.19,
    lng: 55.28,
    activeCount: 28,
  },
  {
    id: 3,
    lat: 25.22,
    lng: 55.25,
    activeCount: 20,
  },
  {
    id: 4,
    lat: 25.18,
    lng: 55.3,
    activeCount: 22,
  },
  {
    id: 5,
    lat: 25.23,
    lng: 55.27,
    activeCount: 24,
  },
  {
    id: 6,
    lat: 25.21,
    lng: 55.32,
    activeCount: 21,
  },
  {
    id: 7,
    lat: 25.25,
    lng: 55.29,
    activeCount: 26,
  },
  {
    id: 8,
    lat: 25.17,
    lng: 55.26,
    activeCount: 23,
  },
]

const totalActiveCustomers = 1500

const employees = [
  {
    id: 1,
    name: "ahmed mohamed ibrahim",
    jopTitle: "UI-UX",
    punchIn: "9:00 AM",
    punchOut: "12:00 PM",
    locationType: "destination",
    phone: "012345678912",
    coordinates: {
      lat: 40.7128, // New York, USA
      lng: -74.006,
    },
    avatar: require("../../../../assets/images/users/avatar-1.jpg"),
  },
  {
    id: 2,
    name: "ali mahmoud ahmed",
    jopTitle: "Front-End",
    punchIn: "9:00 AM",
    punchOut: null,
    locationType: "office",
    phone: "012345678912",
    coordinates: {
      lat: 48.8566, // Paris, France (Europe)
      lng: 2.3522,
    },
    avatar: require("../../../../assets/images/users/avatar-2.jpg"),
  },
  {
    id: 3,
    name: "shref mahmoud ali",
    jopTitle: "Back-End",
    punchIn: null,
    punchOut: null,
    locationType: null,
    phone: "012345678912",
    coordinates: {
      lat: 30.0444, // Cairo, Egypt (Africa)
      lng: 31.2357,
    },
    avatar: require("../../../../assets/images/users/avatar-3.jpg"),
  },
  {
    id: 4,
    name: "yassen mahmoud ahmed",
    jopTitle: "Mobile",
    punchIn: "9:00 AM",
    punchOut: null,
    locationType: "destination",
    phone: "012345678912",
    coordinates: {
      lat: 35.6895, // Tokyo, Japan (Asia)
      lng: 139.6917,
    },
    avatar: require("../../../../assets/images/users/avatar-4.jpg"),
  },
  {
    id: 5,
    name: "essam mahmoud ahmed",
    jopTitle: "Full-Stack",
    punchIn: "9:00 AM",
    punchOut: null,
    locationType: "destination",
    phone: "012345678912",
    coordinates: {
      lat: -33.8688, // Sydney, Australia
      lng: 151.2093,
    },
    avatar: require("../../../../assets/images/users/avatar-5.jpg"),
  },
  {
    id: 6,
    name: "hassan mahmoud ahmed",
    jopTitle: "DevOps",
    punchIn: "9:00 AM",
    punchOut: null,
    locationType: "destination",
    phone: "012345678912",
    coordinates: {
      lat: -23.5505, // São Paulo, Brazil (South America)
      lng: -46.6333,
    },
    avatar: require("../../../../assets/images/users/avatar-6.jpg"),
  },
]

export const ActiveCustomers = () => {
  const [state, setState] = useState({
    lat: 25.2048,
    lng: 55.2708,
    zoom: 12,
  })

  const { i18n } = useTranslation()

  const position: [number, number] = [state.lat, state.lng]

  // Create custom blue circle marker with number
  const createCustomMarker = (count: number) => {
    return Leaflet.divIcon({
      className: "custom-map-marker",
      html: `
        <div
          style="
            background-color: #1E88E5;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: 600;
            font-size: 14px;
            border: 3px solid white;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
          "
        >
          ${count}
        </div>
      `,
      iconSize: [48, 48],
      iconAnchor: [24, 24],
    })
  }

  return (
    <div className="d-flex flex-column gap-3 h-100">
      {/* Header with hamburger menu */}
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <h4 className="font-size-16 text-capitalize fw-semibold mb-4">
            {i18n.t("dashboard_activeCustomers")}
          </h4>
        </div>
      </div>

      <div className="flex-grow-1" style={{ position: "relative" }}>
        <Map
          center={position}
          zoom={state.zoom}
          style={{ height: "100%", width: "100%", borderRadius: "12px" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          {customerLocations.map(location => (
            <Marker
              key={location.id}
              position={[location.lat, location.lng]}
              icon={createCustomMarker(location.activeCount)}
            />
          ))}
        </Map>
      </div>

      {/* Footer Summary */}
      <div className="d-flex py-2">
        <span className="font-size-14 fw-medium" style={{ color: "#6B7280" }}>
          {i18n.t("dashboard_totalActiveUsers")} :{" "}
          <span style={{ color: "#111827", fontWeight: 600 }}>
            {totalActiveCustomers} {i18n.t("dashboard_customers")}
          </span>
        </span>
      </div>
    </div>
  )
}
